import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  FaCheckCircle,
  FaTimesCircle,
  FaSun,
  FaMoon,
  FaGift,
  FaHome,
  FaDumbbell,
} from 'react-icons/fa';

export default function PaymentResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const [dark, setDark] = useState(true);

  const queryParams = new URLSearchParams(location.search);
  const success = queryParams.get('success')?.toLowerCase() === 'true';
  const planId = queryParams.get('planId');

  return (
    <div dir="rtl" className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-[#f8faff] dark:bg-[#070B14] text-slate-900 dark:text-white px-4 font-vazir relative overflow-hidden flex items-center justify-center">
        <div className="fixed top-20 right-[-80px] w-72 h-72 rounded-full bg-purple-500/20 blur-3xl pointer-events-none" />
        <div className="fixed bottom-20 left-[-80px] w-72 h-72 rounded-full bg-blue-500/20 blur-3xl pointer-events-none" />

        <div className="relative z-10 max-w-md w-full">
          <div className="rounded-[2rem] border border-slate-200 dark:border-white/10 bg-white/90 dark:bg-[#10182A]/95 p-6 shadow-2xl text-center backdrop-blur-xl">
            {success ? (
              <>
                <FaCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />

                <h1 className="text-2xl font-black mb-3">
                  پرداخت با موفقیت انجام شد
                </h1>

                <p className="text-sm leading-7 text-slate-500 dark:text-slate-300">
                  برنامه‌ی شما در حال آماده‌سازی است و طی چند ساعت آینده از طریق پیامک اطلاع‌رسانی خواهد شد.
                </p>

                <div className="mt-6 rounded-[1.5rem] border border-purple-500/20 bg-gradient-to-br from-purple-600/20 via-blue-600/10 to-green-500/10 p-5 text-right">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-2xl bg-gradient-to-l from-purple-600 to-blue-500 text-white flex items-center justify-center">
                      <FaGift />
                    </div>

                    <div>
                      <h2 className="font-black text-lg">
                        🎁 حالا نوبت درآمدته
                      </h2>
                      <p className="mt-1 text-xs text-slate-500 dark:text-slate-300">
                        دوستت تخفیف می‌گیرد و تو درآمد کسب می‌کنی
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={() => navigate('/referral')}
                    className="mt-4 w-full py-3 rounded-2xl bg-gradient-to-l from-purple-600 to-blue-500 text-white font-black shadow-lg shadow-purple-500/20"
                  >
                    دعوت دوستان
                  </button>
                </div>

                <div className="grid grid-cols-2 gap-3 mt-5">
                  <button
                    onClick={() => navigate('/dashboard')}
                    className="py-3 rounded-2xl bg-green-500 text-white font-bold flex items-center justify-center gap-2"
                  >
                    <FaDumbbell />
                    داشبورد
                  </button>

                  <button
                    onClick={() => navigate('/')}
                    className="py-3 rounded-2xl bg-slate-100 dark:bg-white/10 font-bold flex items-center justify-center gap-2"
                  >
                    <FaHome />
                    خانه
                  </button>
                </div>
              </>
            ) : (
              <>
                <FaTimesCircle className="text-red-500 text-5xl mx-auto mb-4" />

                <h1 className="text-2xl font-black mb-3">
                  پرداخت ناموفق بود
                </h1>

                <p className="text-sm leading-7 text-slate-500 dark:text-slate-300">
                  پرداخت انجام نشد. می‌تونی دوباره تلاش کنی یا به صفحه پرداخت برگردی.
                </p>

                <button
                  onClick={() => {
                    if (planId) localStorage.setItem('planId', planId);
                    navigate('/payment');
                  }}
                  className="mt-6 w-full py-3 rounded-2xl bg-red-600 hover:bg-red-700 text-white font-black"
                >
                  بازگشت به پرداخت
                </button>

                <button
                  onClick={() => navigate('/')}
                  className="mt-3 w-full py-3 rounded-2xl bg-slate-100 dark:bg-white/10 font-bold"
                >
                  بازگشت به صفحه اصلی
                </button>
              </>
            )}
          </div>
        </div>

        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 w-11 h-11 bg-white dark:bg-[#10182A] border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white rounded-2xl shadow-lg flex items-center justify-center"
        >
          {dark ? (
            <FaSun className="text-yellow-400" />
          ) : (
            <FaMoon className="text-blue-500" />
          )}
        </button>
      </div>
    </div>
  );
}